import { Col, Row } from 'reactstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import Input from 'src/componentes/input';
import TipoCargoLookup from 'src/lookups/tipo-cargo';
import CriticidadeCargoLookup from 'src/lookups/CriticidadeCargoLookup';

const CargoSearch = ({ model, resources, intl }) => {
  return (
    <>
      <Row>
        <Col md={12}>
          <Input model={model.getModel('idIntegracao')} />
        </Col>
        <Col md={12}>
          <Input model={model.getModel('nome')} />
        </Col>
        <Col md={12}>
          <TipoCargoLookup
            multi
            clearable
            model={{
              label: intl.formatMessage(
                { id: 'tipoCargo' },
                { cargo: resources.cargo }
              ),
              value: model.getModel('tipoCargo').value,
              requestChange: model.getModel('tipoCargo').requestChange,
            }}
          />
        </Col>
        <Col md={12}>
          <CriticidadeCargoLookup
            multi
            clearable
            model={model.getModel('criticidade')}
          />
        </Col>
        <Col md={12}>
          <Input type="textarea" rows={3} model={model.getModel('descricao')} />
        </Col>
      </Row>
    </>
  );
};

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
  };
}
export default injectIntl(connect(mapStateToProps)(CargoSearch));
